import { OpenInstanceFromFileResponse as ProtoOpenInstanceFromFileResponse } from "@opstel/gen/knop/ui/v1/api/instance_loading_pb";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { z } from "zod/v3";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";

export interface OpenInstanceFromFileResponse {
  status: ResponseStatus;
  instanceId: string;
  correlationOperationId: string;
  correlationParentId: string;
  correlationCurrentId: string;
}
export const openInstanceFromFileResponseSchema = createSchema<
  OpenInstanceFromFileResponse,
  PlainMessage<ProtoOpenInstanceFromFileResponse>
>({
  status: responseStatusSchema,
  description: z.string(),
  instanceId: z.string(),
  correlationOperationId: z.string(),
  correlationParentId: z.string(),
  correlationCurrentId: z.string(),
}).refine(
  (message) =>
    message.status !== "SUCCESS" || z.string().uuid().safeParse(message.instanceId).success,
  {
    message: "instance should have a valid guid as instance id",
  },
) as ZodOutputFor<OpenInstanceFromFileResponse>;
